import { membersApi } from "@services/apiMembersClient";
import { ResponsePaginationType } from "@_types/shared";
import {
  CreateTeamInput,
  CreateTeamOutput,
  CreateTransferStudentsFromTeamInput,
  CreateTransferStudentsFromTeamOutput,
  DeleteTeamByIdInput,
  DeleteTeamInput,
  GetTeamByIdInput,
  GetTeamByIdOutput,
  GetTeamInput,
  GetTeamOutput,
} from "@_types/teams";
import { AxiosPromise } from "axios";

export const createTeam = ({ ...data }: CreateTeamInput): AxiosPromise<CreateTeamOutput> => {
  return membersApi.post("/teams", { ...data });
};

export const updateTeam = (uuid: string, { ...data }: CreateTeamInput): AxiosPromise<CreateTeamOutput> => {
  return membersApi.patch(`teams/${uuid}`, { ...data });
};

export const createTransferStudentsFromTeam = (
  data: CreateTransferStudentsFromTeamInput
): AxiosPromise<CreateTransferStudentsFromTeamOutput> => {
  return membersApi.post("/teams/migrate", data);
};

export const getTeam = ({
  page,
  pageSize,
  search,
}: GetTeamInput): AxiosPromise<ResponsePaginationType<GetTeamOutput>> => {
  return membersApi.get("/teams", {
    params: {
      page,
      pageSize,
      search,
    },
  });
};

export const getTeamById = ({ uuid }: GetTeamByIdInput): AxiosPromise<GetTeamByIdOutput> => {
  return membersApi.get(`/teams/${uuid}`);
};

export const deleteTeam = (uuids: DeleteTeamInput): AxiosPromise<void> => {
  return membersApi.delete(`/teams/to-delete`, { data: uuids });
};

export const deleteTeamById = ({ uuid }: DeleteTeamByIdInput): AxiosPromise<void> => {
  return membersApi.get(`/teams/${uuid}`);
};
